import type {ProductSearchDocument} from '@/lib/search/types'

/** Reject error envelopes before they can replace products with an empty list. */
export async function readProductSearchResponse(
  response: Response,
): Promise<{hits: ProductSearchDocument[]; total: number}> {
  const {hits, total, enabled}: {hits?: unknown; total?: unknown; enabled?: unknown} =
    (response.ok ? await response.json() : null) ?? {}
  if (
    !Array.isArray(hits) ||
    !hits.every((hit: unknown) => hit !== null && typeof hit === 'object' && !Array.isArray(hit)) ||
    !Number.isFinite(total) ||
    (total as number) < 0 ||
    enabled === false
  ) {
    throw new Error('Invalid product search response')
  }
  return {hits: hits as ProductSearchDocument[], total: total as number}
}
